import request from '@/utils/request'

export function forget(emailReceiver) {
    return request({
        url: `api/email/forget/user/code/forget${emailReceiver}`,
        method: 'get',
    })
}